export default "__VITE_ASSET__Is5_n_Ww__"